export { default as PopularDesktop } from './PopularDesktop';



// WEBPACK FOOTER //
// ./src/containers/HomePage/PopularCategories/PopularDesktop/index.ts